import { render } from "./WorkerSelector.vue?vue&type=template&id=5b1c54e4&scoped=true"
import script from "./WorkerSelector.vue?vue&type=script&lang=js"
export * from "./WorkerSelector.vue?vue&type=script&lang=js"

import "./WorkerSelector.vue?vue&type=style&index=0&id=5b1c54e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1c54e4"]])

export default __exports__